'use strict';

import ApexCharts from 'apexcharts';

function LotteryDistributionGraph ($el) {
  this.$el = $el;
  this.color = $el.getAttribute('data-color') || '#ccc';

  try {
    this.series = JSON.parse($el.getAttribute('data-series') || '[]');
    this.labels = JSON.parse($el.getAttribute('data-labels') || '[]');
  } catch (err) {
    console.error(err);
    return;
  }

  const options = {
    series: this.series,
    chart: {
      width: 380,
      type: 'pie'
    },
    labels: this.labels,
    fill: {
      opacity: 1
    },
    stroke: {
      width: 1,
      colors: undefined
    },
    yaxis: {
      show: false
    },
    tooltip: {
      fixed: true,
      shared: false,
      followCursor: false,
      intersect: false,
      y: {
        show: true,
        formatter: (a) => {
          return a + '%';
        }
      }
    },
    legend: false,
    plotOptions: {
      polarArea: {
        rings: {
          strokeWidth: 0
        }
      }
    },
    theme: {
      monochrome: {
        enabled: true,
        color: this.color,
        shadeTo: 'light',
        shadeIntensity: 0.6
      }
    },
    responsive: [{
      breakpoint: 480,
      options: {
        chart: {
          width: 200
        }
      }
    }]
  };

  const chart = new ApexCharts(this.$el, options);
  chart.view();
}

(function () {
  const els = document.querySelectorAll(
    '[data-vanilla="LotteryDistributionGraph"]'
  );

  if (els.length) {
    for (const $el of els) {
      new LotteryDistributionGraph($el);
    }
  }
})();
